import { hallTicketsActionTypes } from 'src/store/actions';

const initialState = {};

const HallTicketsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case hallTicketsActionTypes.GET_ALL_STUDENTS_HALL_TICKETS:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default HallTicketsReducer;
